export default "__VITE_ASSET__CWz79_bt__"